import runningCat from "./Running Cat.json";
import doubtsChatLoader from "./DoubtsChatLoader.json";
import blueLoader from "./blue_loader.json";
import timer from "./timer.json";

export const animations = {
  runningCat,
  doubtsChatLoader,
  blueLoader,
  timer,
};
